"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormLabelStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
const FormLabelStyled = (0, _styled.default)("div")`
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 1fr;
`;
exports.FormLabelStyled = FormLabelStyled;
//# sourceMappingURL=FormLabelStyled.js.map